<template>
  <div id="rodzajoferty">
    <T1Breadcrumbs class="mb-24" :homeLink="true" :items="getBreadcrumbs()" />
    <h2 class="font-24 font-r">
      Podróżuj tak jak lubisz z TravelOne.pl &reg;
    </h2>
    <a-row :gutter="[32, 32]" type="flex">
      <template v-for="(oferta, i) in getOferty()">
        <a-col :sm="12" :lg="8" :key="i">
          <T1OfferTypeCard :oferta="oferta" :cena="getCenaForOferta(oferta)" />
        </a-col>
      </template>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";
import T1OfferTypeCard from "./T1OfferCards/T1OfferTypeCard";
import * as CONFIG from "./config.js";

axios.defaults.withCredentials = false;

export default {
  data: () => ({
    url: "/getrodzajoferty.xml",
    cenyurl: "/getrodzajofertyceny.json",
    oferty: [],
    disabled: ["lato2016", "lato2017", "lato2018", "lato2019", "lato2020"],
    ceny: [],
    cenyOferta: {}
  }),
  methods: {
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push({
        name: "Rodzaje ofert",
        link: ""
      });
      return crumbsArr;
    },
    getCenaForOferta(oferta) {
      if (this.cenyOferta[oferta.child.prefix]) {
        return this.cenyOferta[oferta.child.prefix];
      } else {
        return {};
      }
    },
    getCeny() {
      return axios
        .get(CONFIG.API_URL + this.cenyurl, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          }
        })
        .then(response => {
          /*alert("DATA:" + response.data);
            alert("STATUS:" + response.status);
            alert("DATA ITEMS:" + JSON.stringify(response.data));*/
          return response.data;
        })
        .catch(e => {
          alert("ERROR" + e);
        });
    },
    getOferty() {
      var that = this;
      return this.oferty.filter(function(elem, index) {
        if (that.disabled.includes(elem.child.nazwa)) {
          return false;
        } else {
          return true;
        }
      });
    },
    getRodzajOfertyData() {
      var that = this;
      var rodzajUrl = CONFIG.API_URL + this.url;
      var result = jQuery.ajax({
        url: rodzajUrl,
        dataType: "xml",
        crossDomain: true,
        method: "GET",
        success: function(data) {
          var xmlObj = jQuery(data);
          var arr = [];
          xmlObj.find("item").each(function(index) {
            var newObj = {};
            newObj.show = jQuery(this).attr("show");
            newObj.zdjecie = jQuery(this).attr("zdjecie");
            newObj.url = jQuery(this).attr("url");
            var subObj = {};
            subObj.prefix = jQuery(this)
              .find("prefix")
              .text();
            subObj.nazwa = jQuery(this)
              .find("nazwa")
              .text();
            subObj.pnazwa = jQuery(this)
              .find("pnazwa")
              .text();
            subObj.snazwa = jQuery(this)
              .find("snazwa")
              .text();
            subObj.tekstzb = jQuery(this)
              .find("tekstzb")
              .html();
            newObj.child = subObj;
            if (that.cenyOferta[subObj.prefix]) {
              arr.push(newObj);
            }
          });
          // console.log("items:" + arr.length);
          // console.log(arr);
          that.oferty = arr.slice(1);
        },
        error: function(e) {
          console.log(e);
          console.log("Ajax Error");
        }
      });
      return result;
    }
  },
  mounted() {
    var that = this;
    this.getCeny().then(data => {
      //alert("OFERTY:" + JSON.stringify(data.page));
      this.ceny = data.page.GrupyDost;
      this.ceny.forEach(function(value) {
        var id = value.id;
        var name = value.name;
        var key = name + "=" + id;
        if (typeof value.cenamin === "string") {
          that.cenyOferta[key] = value;
        }
      });
      this.getRodzajOfertyData();
    });
  },
  components: {
    T1Breadcrumbs,
    T1OfferTypeCard
  }
};
</script>
